// extracted by mini-css-extract-plugin
export var downArrow = "_73-0";
export var label = "_73-1";
export var treatmentCard = "_73-3";
export var upArrow = "_73-2";